import InvalidBankAccountAlert from "./InvalidBankAccountAlert"

export default InvalidBankAccountAlert
